import React, { useContext } from 'react';
import AppContext from '../context';
import { PostWrapper, InnerPostWrapper } from '../elements';

export const Post = ({ children }) => {
  const { dark } = useContext(AppContext);
  return (
    <PostWrapper dark={dark}>
      <InnerPostWrapper dark={dark}>{children}</InnerPostWrapper>
    </PostWrapper>
  );
};
